import styled from 'styled-components';
import { LINK, PRIMARY, BG_LIGHT_BLUE, TEXT } from '../../shared/styles/colors';
import { flexBox, fontSize } from '../../shared/styles/mixins'
import { Button } from '@material-ui/core'

export const NavButton = styled(Button)`
  &.MuiButton-outlinedSizeSmall {
    text-align: center;
    width: 145px;
    font-size: .75rem;
    font-weight: 300;
    margin-bottom: 0;
  }
`;

export const Wrapper = styled.section`
  max-width: 768px;
  width: 100%;
  align-self: flex-start;
  margin-top: auto;
  @media (max-width: 1280px) {
    min-width: unset;
    width: auto;
    padding-right: 12px;
  }
`;

export const TopHeader = styled.section`
  background-color: ${BG_LIGHT_BLUE};
  height: 40px;
  width: 100%;
  margin-bottom: 33px;
  ${flexBox('row', 'flex-start')};
  padding-left: 400px;
  position: relative;
`;

export const LinkList = styled.ul`
  display: flex;
  align-items: center;
  @media (min-width: 1280px) {
    width: 532px;
    justify-content: flex-end;
  }
`;

export const Item = styled.li`
  cursor: pointer;
  font-size: 12px;
  font-weight: normal;
  color: ${TEXT};
  padding: ${({ padding = '0 4px' }) => padding};
  position: relative;

  @media (min-width: 1028px) {
    ${fontSize(14)}
    &:hover {
      text-decoration: underline;
    }
  }

  & > a.active {
    font-weight: 600;
  }

  ${({ divider }) => divider && `
    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      height: 100%;
      width: 1px;
      background-color: ${TEXT};
    }
  `}
`;

export const PrimaryButton = styled.button`
  border: 1px solid ${PRIMARY};
  border-radius: 25px;
  color: ${PRIMARY};
  font-size: 11.2px;
  font-weight: 600;
  line-height: normal;
  padding: 8px 27px 8px 28px;
`;